export { default, loader } from "/tmp/build/apps/asap/src/routes/auth/forgotten-password.tsx";